import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { DeploymentsCard } from '../../components/deployments/DeploymentsCard';

export const deploymentsEntityCard = EntityCardBlueprint.make({
  name: 'deployments',
  params: {
    // Show on all Component entities (covers service, kservice, frontend,
    // gateway, cronjob, job, event-handler, ai-service, migration)
    filter: { kind: 'component' },
    type: 'content',
    loader: async () => <DeploymentsCard />,
  },
});
